module.exports = __WEBPACK_EXTERNAL_MODULE_d3__;